"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTagController = void 0;
var CustomTagController_1 = require("./CustomTagController");
Object.defineProperty(exports, "CustomTagController", { enumerable: true, get: function () { return __importDefault(CustomTagController_1).default; } });
